import React from 'react'
import Cookie from 'js-cookie'
import { Button, Popup, Select, Icon } from 'semantic-ui-react'

const ORDER_VIEW_HOURS = [
  { key: 2, value: 2, text: 'Last 2 Hours' },
  { key: 3, value: 3, text: 'Last 3 Hours' },
  { key: 6, value: 6, text: 'Last 6 Hours' },
  { key: -1, value: -1, text: 'All Orders' },
]

export default class Setting extends React.Component {
  state = {
    orderViewHours: 2,
    shouldSyncDrivers: false,
  }

  componentDidMount() {
    const orderViewHours = Number(Cookie.get('order_view_hours')) || 2
    const shouldSyncDriversCookie = Cookie.get('should_sync_drivers')
    const shouldSyncDrivers = shouldSyncDriversCookie === undefined ? true : (shouldSyncDriversCookie === 'true')

    this.setState({ orderViewHours, shouldSyncDrivers })
  }

  onViewHourChange = (e, { value }) => this.setState({ orderViewHours: value })

  onSyncChange = () => {
    const { shouldSyncDrivers } = this.state

    this.setState({ shouldSyncDrivers: !shouldSyncDrivers })
  }

  onSave = () => {
    const { shouldSyncDrivers, orderViewHours } = this.state

    Cookie.set('should_sync_drivers', shouldSyncDrivers, { expires: 30 })
    Cookie.set('order_view_hours', orderViewHours, { expires: 30 })

    window.location.reload()
  }

  render() {
    const { shouldSyncDrivers, orderViewHours } = this.state

    return (
      <Popup
        trigger={<Button floated="right">Setting</Button>}
        position="left center"
        on={['click']}
      >
        <Select
          compact
          value={orderViewHours}
          style={{ width: 170 }}
          options={ORDER_VIEW_HOURS}
          onChange={this.onViewHourChange}
        />
        <div style={{ marginTop: 5, marginBottom: 10 }}>
          <Button
            style={{ width: 170 }}
            onClick={this. onSyncChange}
            color={shouldSyncDrivers ? 'red' : 'green'}
          >
            {shouldSyncDrivers ? 'Stop Sync Drivers' : 'Start Sync Drivers'}
          </Button>
        </div>

        <Button floated='right' onClick={this.onSave}>
          Go
          <Icon name="arrow right" />
        </Button>
      </Popup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/Setting.js